import React, { useState } from "react";
import { Nav, Navbar, Container } from 'react-bootstrap';
import logo from "../assets/img/logo.png";
import { Link, NavLink } from 'react-router-dom';
import LetsConnectModal from  "../components/LetsConnectModal";
const Header = ({openModal}) => {
    const [expanded, setExpanded] = useState(false);
    const [letsconnect, setLetsconnect] = useState(false);
    const handleToggle = () => setExpanded(!expanded)
    const LetsconnectToggle = () => setLetsconnect(!letsconnect)
    const closeNav = () => setExpanded(false);
    return (<>
        <Navbar expanded={expanded} expand="lg" fixed="top" className="header">
            <Container>
                {/* <Navbar.Brand as={Link} to="/" onClick={closeNav}> */}
                <a href="/" className="navbar-brand">
                    <img src={logo} className="img-fluid " alt="" />
                </a>
                {/* </Navbar.Brand> */}
                <Navbar.Toggle aria-controls="basic-navbar-nav" onClick={handleToggle} />
                <Navbar.Collapse id="basic-navbar-nav">
                    <Nav className="ms-auto">
                        <Nav.Link as={NavLink} to="/" onClick={closeNav}>Home</Nav.Link>
                        <Nav.Link as={NavLink} to="/aboutus" onClick={closeNav}>About Us</Nav.Link>
                        <Nav.Link as={NavLink} to="/ourprojects" onClick={closeNav}>Our Projects</Nav.Link>
                    </Nav>
                    <Nav className="ms-auto align-items-lg-center right-menu">
                        {/* <Nav.Link as={Link} className="btn btn-primary" onClick={LetsconnectToggle}>Let's Connect<svg className="ms-2" width="27" height="8" viewBox="0 0 27 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M26.3536 4.35355C26.5488 4.15829 26.5488 3.84171 26.3536 3.64645L23.1716 0.464466C22.9763 0.269204 22.6597 0.269204 22.4645 0.464466C22.2692 0.659728 22.2692 0.976311 22.4645 1.17157L25.2929 4L22.4645 6.82843C22.2692 7.02369 22.2692 7.34027 22.4645 7.53553C22.6597 7.7308 22.9763 7.7308 23.1716 7.53553L26.3536 4.35355ZM0 4.5H26V3.5H0V4.5Z" fill="white" />
                        </svg>
                        </Nav.Link> */}
                        <Nav.Link as={Link} className="btn btn-primary"         onClick={() => openModal("Let's Connect", "Enter your details and let's get in touch!")}
                        >Let's Connect<svg className="ms-2" width="27" height="8" viewBox="0 0 27 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M26.3536 4.35355C26.5488 4.15829 26.5488 3.84171 26.3536 3.64645L23.1716 0.464466C22.9763 0.269204 22.6597 0.269204 22.4645 0.464466C22.2692 0.659728 22.2692 0.976311 22.4645 1.17157L25.2929 4L22.4645 6.82843C22.2692 7.02369 22.2692 7.34027 22.4645 7.53553C22.6597 7.7308 22.9763 7.7308 23.1716 7.53553L26.3536 4.35355ZM0 4.5H26V3.5H0V4.5Z" fill="white" />
                    </svg>
                        </Nav.Link>
                    </Nav>
                </Navbar.Collapse>
            </Container>
        </Navbar>
        
        </>
    )
}

export default Header;